var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 1.16733C14.6663 1.16733 14.1997 2.56733 13.333 3.434C14.3997 10.1007 7.06634 14.9673 1.33301 11.1673C2.79967 11.234 4.26634 10.7673 5.33301 9.834C1.99967 8.834 0.333008 4.90067 1.99967 1.834C3.46634 3.56733 5.73301 4.56733 7.99967 4.50067C7.39967 1.70067 10.6663 0.100666 12.6663 1.96733C13.3997 1.96733 14.6663 1.16733 14.6663 1.16733Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b4d69f6a0049f3dda6cceab2aa15fb79.svg";
export { ForwardRef as ReactComponent };